<template>
    <div class="input-container" :class="{enableCopy: data.enableCopy}">
        <div class="input-wrapper">
            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-if="data.formType === 'select' && data.formVisible">
                <LanogaSelect
                        ref="selectInput"
                        :key="selectKey"
                        v-model="modelValue"
                        :title="data.tooltipText"
                        :readonly="data.formReadOnly"
                        :required="data.formRequired && !data.formReadOnly"
                        :showPopOver="data.showPopOver"
                        :options="data.selectOptions"
                        :name="data.name"
                        :externalOptionList="data.selectOptions.externalOptionList"
                        :additional-api-callback-params="data.selectOptions.additionalApiCallbackParams"
                        @cleared="clearSelect">
                </LanogaSelect>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>

            <div v-else-if="data.formType === 'address'">
                <AddressInput
                        :required="data.formRequired"
                        :readOnly="data.formReadOnly"
                        :data="data"
                        v-model="modelValue">
                </AddressInput>
            </div>

            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.formType === 'textarea'">
                <b-form-textarea
                        :required="data.formRequired"
                        :readonly="data.formReadOnly"
                        v-model="modelValue"
                        :placeholder="data.label"
                        rows="3"
                        max-rows="6"/>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.formType === 'textarea_resizable'">
                <b-form-textarea
                        :required="data.formRequired"
                        :readonly="data.formReadOnly"
                        v-model="modelValue"
                        :placeholder="data.label"/>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(modelValue)}"
                            v-else-if="data.formType === 'xlsFileInput'">
                <b-overlay :show="busy" rounded="lg" opacity="0.6">

                <template #overlay>
                    <div class="d-flex align-items-center">
                        <b-spinner small type="grow" variant="secondary"></b-spinner>
                        <b-spinner type="grow" variant="dark"></b-spinner>
                        <b-spinner small type="grow" variant="secondary"></b-spinner>
                    </div>
                </template>

                <div @click="clickInput">
                    <b-form-file
                        ref="fileInput"
                        v-model="modelValue"
                        :state="isValidFile === null ? null : isValidFile"
                        :placeholder="data.label"
                        :drop-placeholder="data.label"
                        accept=".xlsx"
                        browse-text="Tallózás"
                        :size="data.fileSize"
                        :required="data.formRequired"
                        :readonly="data.formReadOnly"
                        :multiple="data.multipleFile"
                        @change="validateFile">
                    </b-form-file>
                </div>

                </b-overlay>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ 'Feltöltés...' }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.name === 'emailBody'">
                <label class="header-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
                <quill-editor
                        :required="data.formRequired"
                        :readonly="data.formReadOnly"
                        v-model="modelValue"
                        :options="quillOptions"
                        @blur="onEditorBlur($event)"
                        @focus="onEditorFocus($event)"
                        @ready="onEditorReady($event)">
                </quill-editor>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.name === 'socialInsuranceNumber' || data.name === 'pSocialInsuranceNumber' || data.name === 'patientSocialInsuranceNumber'||data.name === 'patient.socialInsuranceNumber'">
                <b-form-input
                        :type="inputType"
                        v-model="modelValue"
                        v-mask="'###-###-###'"
                        size="sm"
                        :placeholder="data.label"
                        :readonly="data.formReadOnly"
                        :required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.name === 'ccCode'">
                <b-form-input
                        type="text"
                        v-model="modelValue"
                        :maxLength="2"
                        :placeholder="data.label"
                        :formatter="formatCodeCC"
                        :readonly="data.formReadOnly"
                        :required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.name === 'kaszCode'">
                <b-form-input
                        :type="inputType"
                        v-model="modelValue"
                        :maxLength="25"
                        :placeholder="data.label"
                        :readonly="data.formReadOnly"
                        :required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.formType === 'tel'">
                <vue-tel-input
                        :required="data.formRequired"
                        :readonly="data.formReadOnly"
                        v-model="modelValue"
                        v-bind="telInputOptions"
                        aria-placeholder="">
                </vue-tel-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.formType==='date'">
                <date-picker :value="formatDate"
                             @input="modelValue = $event"
                             :config="datePickerOptions"
                             :readonly="data.formReadOnly"
                             :required="data.formRequired">
                </date-picker>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <div v-else-if="data.formType==='hour'" style="border: 1px #ced4da solid; border-radius: 5px;">
                <input type="time"
                       :readonly="data.formReadOnly"
                       :required="data.formRequired"
                       id="hour"
                        @input="exportData(value)"
                       v-model="value"/>
                <label :class="{'required': data.formRequired}" for="hour" >
                    {{ data.label }}
                </label>
            </div>
            <div v-else-if="data.formType==='hourWithSeconds'" style="border: 1px #ced4da solid; border-radius: 5px;">
              <input type="time"
                     :readonly="data.formReadOnly"
                     :required="data.formRequired"
                     id="hourWithSeconds"
                     v-model="modelValue"/>
              <label :class="{'required': data.formRequired}" for="hour" >
                {{ data.label }}
              </label>
            </div>

            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.formType==='dateMonth'">
                <date-picker :value="formatDate"
                             @input="modelValue = $event"
                             :config="dateMonthPickerOptions"
                             :readonly="data.formReadOnly"
                             :required="data.formRequired">
                </date-picker>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.formType==='dateTime'">
                <date-picker :value="formatDate"
                             :title="data.tooltipText"
                             @input="modelValue = $event"
                             :config="dateTimePickerOptions"
                             :readonly="data.formReadOnly"
                             :required="data.formRequired">
                </date-picker>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.formType==='time'">
                <input :value=formatDateTime
                       :type="inputType"
                       size="sm"
                       class="form-control form-control-sm"
                       :placeholder="data.label"
                       @input="modelValue = $event"
                       :readonly="data.formReadOnly"
                       :required="data.formRequired">
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.formType==='checkboxes'">
                <Checkboxes ref="Checkboxes"
                            :value="modelValue"
                            :name="data.name"
                            :label="data.label"
                            :options="data.checkboxesOptions"
                            :additional-api-callback-params="data.checkboxesOptions.additionalApiCallbackParams"
                            @input="modelValue = $event">
                </Checkboxes>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.formType==='checkbox'">
                <small class="form-text text-muted smooth-label-description" v-html="data.description"
                       v-if="data.description"/>
                <b-form-checkbox
                        v-model="modelValue"
                        :name="data.name"
                        value="true"
                        :disabled="data.formReadOnly"
                        unchecked-value="false">
                    {{data.label}}
                </b-form-checkbox>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.formType==='customRadioButton'">
                <CustomRadioButtonGroup :label="data.label"
                                        :label-cols="true"
                                        :content-cols="true"
                                        v-model="modelValue">
                </CustomRadioButtonGroup>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(modelValue)}"
                          v-else-if="data.formType==='number'">
                <small class="form-text text-muted smooth-label-description" v-html="data.description"
                       v-if="data.description"/>
                <b-form-input :type="inputType"
                              v-model="modelValue"
                              size="sm"
                              :placeholder="data.label"
                              :step="data.numberStep ? data.numberStep : 1"
                              :min="data.numberMin"
                              :readonly="data.formReadOnly"
                              :required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>

            <b-form-group v-else-if="data.formType==='dynamicListInput'">
                <DynamicListInput v-model="modelValue" :config="data.dynamicListInputConfig"/>
            </b-form-group>

            <!-- Single Selection BNO Dialog -->
            <b-form-group :class="{filled: checkFilled(modelValue)}" v-else-if="data.formType==='selectBNOSingle'">
                <SelectBNOSingleDialog :value="modelValue" :label="data.label" :options="data.selectOptions" :required="data.formRequired" @input="modelValue = $event"/>
            </b-form-group>
            <!-- Single Selection Medication Dialog -->
            <b-form-group :class="{filled: checkFilled(value)}" v-else-if="data.formType==='selectMedicationSingle'">
                <SelectMedicationSingleDialog :value="modelValue" :label="data.label" :options="data.selectOptions" :required="data.formRequired" @input="exportData"/>
            </b-form-group>
            <!-- Generic text/other input -->
           <b-form-group :class="{filled: checkFilled(modelValue), 'd-none': !data.formVisible}" v-else>
                <small class="form-text text-muted smooth-label-description" v-html="data.description"
                       v-if="data.description"/>
                <b-form-input :type="inputType"
                              v-model="modelValue"
                              size="sm"
                              :maxLength="data.maxLength"
                              :placeholder="data.label"
                              :readonly="data.formReadOnly"
                              :required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
        </div>
        <div class="icon-wrapper" v-if="data.enableCopy" @click="copyToClipboard" ref="copyWrapper">
            <span><i class="far fa-copy"/></span>
        </div>
    </div>
</template>

<!--Masking: https://vuejs-tips.github.io/vue-the-mask/ -->
<!--QUILL EDITOR DOC: https://github.com/surmon-china/vue-quill-editor -->

<script>
    import AddressInput from "./AddressInput";
    import LanogaSelect from "./LanogaSelect";
    import Checkboxes from "./Checkboxes";
    import DynamicListInput from "./DynamicListInput"
    import SelectBNOSingleDialog from "@/components/SelectBNOSingleDialog";
    import CustomRadioButtonGroup from '@/components/CustomRadioButtonGroup.vue';
    import SelectMedicationSingleDialog from '@/components/SelectMedicationSingleDialog.vue';

    export default {
        name: "FormInputFormat",
        components: {
            SelectBNOSingleDialog,
            Checkboxes,
            LanogaSelect,
            AddressInput,
            DynamicListInput,
            CustomRadioButtonGroup,
            SelectMedicationSingleDialog,
        },
        data() {
            return {
                busy: false,
                isValidFile: null,
                quillOptions: {
                    placeholder: 'Kezdjen el gépelni!'
                },
                telInputOptions: {
                    defaultCountry: "HU",
                    disabledFetchingCountry: false,
                    disabled: false,
                    disabledFormatting: false,
                    placeholder: "Telefonszám",
                    required: false,
                    enabledCountryCode: false,
                    enabledFlags: true,
                    preferredCountries: ["HU"],
                    onlyCountries: [],
                    ignoredCountries: [],
                    autocomplete: "on",
                    name: "telephone",
                    maxLen: 25,
                    wrapperClasses: "",
                    inputClasses: "",
                    mode: "international",
                    dropdownOptions: {
                        disabledDialCode: false
                    },
                    inputOptions: {
                        showDialCode: false
                    }
                },
                datePickerOptions: {
                    format: 'YYYY.MM.DD.',
                    useCurrent: false,
                    collapse: false,
                    locale: this.$moment.locale('hu'),
                    showTodayButton: true,
                    icons: {
                        time: 'far fa-clock',
                        date: 'far fa-calendar',
                        up: 'fas fa-arrow-up',
                        down: 'fas fa-arrow-down',
                        previous: 'fas fa-chevron-left',
                        next: 'fas fa-chevron-right',
                        today: 'fas fa-calendar-check',
                        clear: 'far fa-trash-alt',
                        close: 'far fa-times-circle'
                    }
                },
                dateMonthPickerOptions: {
                    format: 'YYYY.MM.',
                    useCurrent: false,
                    locale: this.$moment.locale('hu'),
                    icons: {
                        time: 'far fa-clock',
                        date: 'far fa-calendar',
                        up: 'fas fa-arrow-up',
                        down: 'fas fa-arrow-down',
                        previous: 'fas fa-chevron-left',
                        next: 'fas fa-chevron-right',
                        today: 'fas fa-calendar-check',
                        clear: 'far fa-trash-alt',
                        close: 'far fa-times-circle'
                    }
                },
                dateTimePickerOptions: {
                    format: 'YYYY.MM.DD. HH:mm',
                    useCurrent: false,
                    locale: this.$moment.locale('hu'),
                    icons: {
                        time: 'far fa-clock',
                        date: 'far fa-calendar',
                        up: 'fas fa-arrow-up',
                        down: 'fas fa-arrow-down',
                        previous: 'fas fa-chevron-left',
                        next: 'fas fa-chevron-right',
                        today: 'fas fa-calendar-check',
                        clear: 'far fa-trash-alt',
                        close: 'far fa-times-circle'
                    }
                },
            }
        },
        props: {
            data: {type: Object},
            value: {type: [String, Number, Object, Array, Boolean, File, Date], required: false}
        },
        computed: {
            inputType() {
                const allowed = [
                'text',
                'number',
                'email',
                'password',
                'tel',
                'date',
                'time',
                'search',
                'url'
                ]

                return allowed.includes(this.data.formType)
                ? this.data.formType
                : 'text'
            },
            selectKey() {
                if (['contactId','partnerHierarchy'].includes(this.data.name)) {
                    return `${this.data.name}-${JSON.stringify(
                        this.data.selectOptions.externalOptionList?.map(o => o.id)
                    )}`
                }
                return this.data.name 
            },
            formatDate() {
                if (this.modelValue) {
                    if (this.data.formType === 'date') {
                        return this.$moment(this.modelValue).format('YYYY-MM-DD');
                    } else if (this.data.formType === 'dateTime') {
                        return this.$moment(this.modelValue).format('YYYY-MM-DD HH:mm:ss');
                    } else if (this.data.formType === 'dateMonth') {
                        return this.$moment(this.modelValue).format('YYYY-MM');
                    } else {
                        return this.modelValue;
                    }
                } else {
                    return this.modelValue;
                }

            },
            formatDateTime() {
                if (this.modelValue) {
                    if (this.data.formType == 'time') {
                        return this.$moment(this.modelValue).format('HH:mm').toString();
                    }else if (this.data.formType === 'hourWithSeconds') {
                      return this.$moment(this.modelValue, 'HH:mm').format('HH:mm')
                    }
                    else {
                        return this.modelValue;
                    }
                } else {
                    return this.modelValue;
                }
            },
            modelValue: {
                get() {                  
                    return this.value
                },
                set(val) {
                    this.emitFormatted(val)
                }
            }
        },
        methods: {
            checkSpecificOption(value) {
                this.$refs.Checkboxes.checkSpecific(value);
            },
            clearSelectInput() {
                this.$refs.selectInput.clear();
            },
            formatCodeCC(value){
                return String(value).replace(/\D/g, '');
            },
            clickInput(){
                this.resetFileData()
            },
            resetFileData() {
                this.$refs.fileInput.reset();
            },
            validateFile(event) {
                const files = event.target.files;
                
                let isValid = true;
                this.busy = true;

                if (!files.length) {
                    this.isValidFile = null;
                    this.busy = false;
                    return;
                }

                setTimeout(() => {
                    for (let i = 0; i < files.length; i++) {
                    const file = files[i];

                        if (!(file.name.endsWith('.xlsx'))) {
                            isValid = false;
                            break;
                        }
                    }

                    this.isValidFile = isValid;

                    if (!this.isValidFile) {
                        this.$toast.error({
                            title: 'Figyelem!',
                            message: 'Kérem a feltöltendő fájlt .xlsx formátumba töltse fel!'
                        });
                    }

                    this.busy = false;
                }, 1500); 
            },
            clearSelect() {
                this.$emit('cleared')
            },
            checkFilled(value) {
                return value !== null
                    && value !== undefined
                    && value !== ''
            },
            emitFormatted(value) {
                let output

                if (this.data.formType === 'date') {
                output = value ? this.$moment(value).format() : undefined

                } else if (this.data.formType === 'dateTime') {
                output = value ? this.$moment(value).format() : undefined

                } else if (this.data.formType === 'hourWithSeconds') {
                output = value
                    ? this.$moment(value, 'HH:mm').format('HH:mm:ss')
                    : undefined

                } else if (this.data.formType === 'checkbox') {
                output = value === 'true' || value === true

                } else {
                output = value
                }

                this.$emit('input', output)
            },
            exportData(value) {
                if (this.data.formType === 'date') {
                    this.$emit('input', value ? this.$moment(value).format() : undefined)
                } else if (this.data.formType === 'dateTime') {
                    this.$emit('input', value ? this.$moment(value).format() : undefined)
                } else if (this.data.formType === 'hourWithSeconds') {
                    this.$emit('input', value ? this.$moment(value, 'HH:mm').format('HH:mm:ss') : undefined)
                } else if (this.data.formType === 'checkbox') {
                    let temp = value === 'true' || value === true;
                    this.$emit('input', temp)
                } else {
                    this.$emit('input', value)
                }
            },
            copyToClipboard() {
                var textArea = document.createElement("textarea");
                textArea.style.position="fixed";  //avoid scrolling to bottom

                if(this.data.formType === 'tel') {
                    textArea.value = this.modelValue.replace(/[ +-]/g, "");
                }
                else if (this.data.label === "TAJ") {
                    textArea.value = this.modelValue.replace(/[ -]/g, "");
                }
                else {
                    textArea.value = this.modelValue;
                }

                this.$refs['copyWrapper'].appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                } catch (err) {
                    //console.error('Fallback: Oops, unable to copy', err);
                }

                this.$refs['copyWrapper'].removeChild(textArea);
            }
        },
        watch: {
        'data.selectOptions.externalOptionList': {
            immediate: true,
            handler(newOptions) {
            if (!newOptions || !this.modelValue) return

            // Check if the current value exists in options
            const match = newOptions.find(
                opt => opt.id === this.modelValue || opt.value === this.modelValue
            )

            if (!match && newOptions.length) {
                // Default to first option if current value invalid
                this.modelValue = newOptions[0].id || newOptions[0].value
            }
            }
        }
        }

    }
</script>

<style scoped>

    .input-container {
        display: flex;
    }

    .icon-wrapper {
        height: 38px !important;
        padding: 0.25rem 0.5rem;
        font-size: 1rem;
        line-height: 1.6;
        border-top: 1px solid #ced4da;
        border-right: 1px solid #ced4da;
        border-bottom: 1px solid #ced4da;
        border-top-right-radius: 0.2rem;
        border-bottom-right-radius: 0.2rem;
        cursor: pointer;
    }

    .input-wrapper {
        flex: 1;
    }

    .input-container.enableCopy input {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .form-group {
        position: relative;
    }

    .smooth-label-description {
        display: none;
        position: absolute;
        bottom: 100%;
        width: 100%;
        background: #fff;
        border: 1px solid lightgray;
        padding: 5px;
    }

    .form-group:hover .smooth-label-description {
        display: block;
    }

    .form-group >>> .status-color {
        width: 20px;
        height: 12px;
        display: inline-block;
        border-radius: 25px;
        border: 1px solid lightgray;
        margin-right: 5px;
    }

    .form-group >>> .status-not-come {
        background-color: var(--status-not-come) !important;
    }

    .form-group >>> .status-arrived {
        background-color: var(--status-arrived) !important;
    }

    .form-group >>> .status-special {
        background-color: var(--status-special) !important;
    }

    .form-group >>> .status-reservation {
        background-color: var(--status-reservation) !important;
    }

    .form-group >>> .status-now-doctor {
        background-color: var(--status-now-doctor)!important;
    }

    .form-group >>> .status-treatment-finished {
        background-color: var(--status-treatment-finished) !important;
    }

    .form-group >>> .status-notified-by-phone {
        background-color: var(--status-notified-by-phone) !important;
    }

    .form-group >>> .status-not-reached-by-phone {
        background-color: var(--status-not-reached-by-phone) !important;
    }

    .form-group >>> .status-partner {
        background-color: var(--status-partner) !important;
    }

    .form-group >>> .status-canceled {
        background-color: var(--status-canceled) !important;
    }

    .form-group >>> .status-doctor {
        background-color: var(--status-doctor) !important;
        opacity: 0.3;
    }

    .form-group >>> .status-api-create {
        background-color: var(--status-api-create) !important;
    }

    .form-group >>> .status-approved {
        background-color: var(--status-approved) !important;
    }

    .form-group >>> .status-rejected {
        background-color: var(--status-rejected) !important;
    }

    .form-group >>> .status-disband {
        background-color: var(--status-disband) !important;
    }

    .form-group >>> .status-canceled-by-doctor {
        background-color: var(--status-canceled-by-doctor) !important;
    }

    .form-group >>> .status-b2c-package {
        background-color: var(--status-b2c-package) !important;
    }

    .form-group >>> .status-b2b-package {
        background-color: var(--status-b2b-package) !important;
    }

    .form-group >>> .status-email-sent {
        background-color: var(--status-email-sent) !important;
    }

    .form-group >>> .status-in-progress {
        background-color: var(--status-in-progress) !important;
    }

    .form-group >>> .status-ready-for-treatment {
        background-color: var(--status-ready-for-treatment) !important;
    }
    .form-group >>> .status-failed-treatment {
        background-color: var(--status-failed-treatment) !important;
    }
    .form-group >>> .status-make-payment {
        background-color: var(--status-make-payment) !important;
    }
    .form-group >>> .status-treatment-finished-with-referral {
        background-color: var(--status-treatment-finished-with-referral) !important;
    }
</style>
